import { ReactNode } from 'react';
import loginBg from '../../../assets/login-bg.png';

export interface AuthShellSide {
  title: ReactNode;
  text: string;
}

interface AuthShellProps {
  side?: AuthShellSide;
  children: ReactNode;
}

const AuthShell = ({ side, children }: AuthShellProps) => (
  <div className="auth-bg relative overflow-hidden">
    <div className="absolute inset-0 z-0">
      <img
        src={loginBg}
        alt="background"
        className="w-full h-full object-cover opacity-40 scale-105 animate-pulse [animation-duration:10s]"
      />
      <div className="absolute inset-0 bg-gradient-to-tr from-[#0A0F14] via-transparent to-[#0A0F14]/50" />
    </div>

    <div className="premium-blur-dot w-[500px] h-[500px] bg-teal-accent top-[-100px] right-[-100px]" />
    <div className="premium-blur-dot w-[400px] h-[400px] bg-teal-primary bottom-[-100px] left-[-100px]" />

    <div className="relative z-10 w-full max-w-[1200px] flex flex-col tablet:flex-row items-center justify-center gap-12 desktop:gap-24 px-4">
      {side && (
        <div className="hidden tablet:flex flex-col items-start gap-6 max-w-[450px] animate-float">
          <div className="bg-white/10 backdrop-blur-md p-4 rounded-2xl border border-white/20 shadow-xl">
            <h3 className="text-white text-3xl desktop:text-4xl plus-jakarta-sans-extrabold leading-tight">
              {side.title}
            </h3>
          </div>
          <p className="text-white/70 text-lg manrope-medium pl-2">
            {side.text}
          </p>
        </div>
      )}

      {children}
    </div>
  </div>
);

export default AuthShell;
